import React from "react";

import StatusScreen from "components/StatusScreen";

export default function NotFound() {
  return (
    <StatusScreen image="illustration-notfound.jpg" title="Oops! We're lost" action={{ to: "/", label: "Back to home" }}>
      The page that you requested is not found in our system.
    </StatusScreen>
  );
}
